exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".accordion__active___3sc28 {\n  display: inherit;\n}\n\n.accordion__inactive___BB4KA {\n  display: none;\n}\n\n.accordion__accordion___1SWwv {\n  background-color: #FFFFFF;\n  border: 1px solid #1EAEDB;\n  border-radius: 5px;\n  border-top-color: #1EAEDB;\n  color: #000000;\n  text-align: left;\n  word-wrap: break-word;\n}\n\n.accordion__accordion___1SWwv a {\n  color: #1EAEDB;\n  display: inline-block;\n  padding: 10px;\n}\n\n.accordion__accordion___1SWwv a:hover {\n  color: #1EAEDB;\n  cursor: pointer;\n}\n\n.accordion__accordion___1SWwv p {\n  background-color: #1EAEDB;\n  color: #FFFFFF;\n  margin-bottom: 0px;\n  padding: 10px;\n}\n", ""]);

// exports
exports.locals = {
	"blue": "#1EAEDB",
	"black": "#000000",
	"white": "#FFFFFF",
	"active": "accordion__active___3sc28",
	"inactive": "accordion__inactive___BB4KA",
	"accordion": "accordion__accordion___1SWwv"
};


//////////////////
// WEBPACK FOOTER
// ./src/styles/accordion.css
// module id = 90
// module chunks = 0